import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { pathFor, type Lang } from '../../../router/paths';

export default function Hero() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const lang: Lang = i18n.language === 'en' ? 'en' : 'de';

  const roomsPath = pathFor('rooms', lang);
  const goToZimmer = () => { navigate(roomsPath); window.scrollTo({ top: 0, behavior: 'instant' }); };

  return (
    <section id="startseite" className="relative h-[100vh] sm:h-screen flex items-end sm:items-center justify-center pb-20 sm:pb-0">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="/images/ambiente/Aussen_Sommer_Hero.webp"
          srcSet="/images/ambiente/Aussen_Sommer_Hero_900w.webp 900w, /images/ambiente/Aussen_Sommer_Hero_1400w.webp 1400w, /images/ambiente/Aussen_Sommer_Hero.webp 2400w"
          sizes="100vw"
          width={2400}
          height={1034}
          alt="Hotel Alpenhof Gauting bei München – Außenansicht im Sommer mit Garten"
          loading="eager"
          fetchPriority="high"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60 sm:to-black/40"></div>
      </div>

      <div className="relative z-10 text-center text-white px-4 sm:px-6 max-w-4xl mx-auto w-full">
        <div className="flex flex-col items-center justify-center gap-4 sm:gap-6 mb-6 sm:mb-6">
          <img
            src="/images/brand/logo_stick.webp"
            alt="Hotel Alpenhof Gauting Logo"
            className="w-24 sm:w-52 md:w-[246px] lg:w-[282px] h-auto"
            style={{ filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.7)) drop-shadow(0 2px 6px rgba(0,0,0,0.5))' }}
          />
          <div className="text-center">
            <h1 className="text-3xl sm:text-5xl md:text-5xl lg:text-6xl font-serif leading-snug sm:leading-tight mb-3 sm:mb-6">
              {t('heroTitle').split('\n').map((line, i, arr) => (
                <span key={i} className={i === arr.length - 1 ? 'text-amber-200' : ''}>
                  {line}
                  {i < arr.length - 1 && (
                    <>
                      <br className="sm:hidden" />
                      <span className="hidden sm:inline"> </span>
                    </>
                  )}
                </span>
              ))}
            </h1>
            <p className="text-sm sm:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
              {t('heroSubtitle')}
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
          <button
            className="d21-trigger-ibe inline-flex justify-center bg-amber-700 text-white px-8 py-3 rounded-md text-sm sm:text-base font-medium hover:bg-amber-600 transition-all duration-300 sm:hover:scale-105 whitespace-nowrap cursor-pointer min-w-[200px]"
          >
            {t('heroCtaPrimary')}
          </button>
          <Link
            to={roomsPath}
            onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
            className="inline-flex justify-center bg-white/10 backdrop-blur-sm text-white border-2 border-white/80 px-8 py-3 rounded-md text-sm sm:text-base font-medium hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer min-w-[200px]"
          >
            {t('heroCtaSecondary')}
          </Link>
        </div>
      </div>
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/70 text-2xl sm:text-3xl"></i>
      </div>
    </section>
  );
}
